import * as React from 'react';
import styled from 'styled-components';
import * as Icon from '../../../icons';
import * as S from '../';

type Value = Record<string, any>;

export type TColorSelect = {
    type: 'color',
    name: string,
    onSelect: (x: unknown, name: string) => void,
    value?: Value | null,
    onClear?: (name: string) => void,
    defaultValue?: Value,
    disabled?: boolean,
}

const Component: React.FunctionComponent<TColorSelect> = ({
    name,
    onSelect,
    value = null,
    onClear,
    defaultValue,
    disabled,
}) => {
    return (
        <S.Select 
            name={name}
            onSelect={onSelect}
            onClear={onClear}>
            <S.Control disabled={disabled}>
                <S.ControlColor
                    value={value}
                    defaultValue={defaultValue}
                />
                <Palette>
                    <Icon.Palette />
                </Palette>
            </S.Control>
            <S.Indicator />
            <Dropdown>
                <S.Color />
            </Dropdown>
            <S.Keyboard />
        </S.Select>
    );
}

export default Component;

const Palette = styled.div`
    border-left: 1px solid #ddd;
    padding-left: 10px;
    margin-right: -5px;
    display: flex;
    align-items: center;
`;

const Dropdown = styled(S.Dropdown)`

    min-width: 400px;

    .flexbox-fix:nth-child(3) {
        float: left;
    }
`;
